export const DEFAULT_PAGINATION_CONTROL_DIMENSION = 44;
export const DEFAULT_PAGINATION_CONTROL_PADDING = 24;
